import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AiAgentChatLayoutService {
  private static readonly STORAGE_KEY = 'ai_agent_chat_width';
  public static readonly DEFAULT_WIDTH = 480;
  public static readonly MIN_WIDTH = 380;
  public static readonly MAX_WIDTH = 860;
  public static readonly EXPANDED_WIDTH = 720;

  readonly width = signal<number>(this._getStoredWidth());
  readonly isDragging = signal<boolean>(false);

  readonly isExpanded = computed<boolean>(
    () => this.width() >= 620
  );

  private _getStoredWidth(): number {
    try {
      const stored = localStorage.getItem(AiAgentChatLayoutService.STORAGE_KEY);

      if (stored !== null) {
        const parsed = parseInt(stored, 10);

        if (
          !isNaN(parsed) &&
          parsed >= AiAgentChatLayoutService.MIN_WIDTH &&
          parsed <= AiAgentChatLayoutService.MAX_WIDTH
        ) {
          return parsed;
        }
      }
    } catch {
      // localStorage unavailable
    }

    return AiAgentChatLayoutService.DEFAULT_WIDTH;
  }

  setWidth(width: number): void {
    const clamped = Math.max(
      AiAgentChatLayoutService.MIN_WIDTH,
      Math.min(width, AiAgentChatLayoutService.MAX_WIDTH)
    );
    this.width.set(clamped);
    this._saveStoredWidth(clamped);
  }

  setDragging(dragging: boolean): void {
    this.isDragging.set(dragging);
  }

  toggleExpanded(): void {
    if (this.isExpanded()) {
      this.setWidth(AiAgentChatLayoutService.DEFAULT_WIDTH);
    } else {
      this.setWidth(AiAgentChatLayoutService.EXPANDED_WIDTH);
    }
  }

  resetWidth(): void {
    this.setWidth(AiAgentChatLayoutService.DEFAULT_WIDTH);
  }

  private _saveStoredWidth(width: number): void {
    try {
      localStorage.setItem(
        AiAgentChatLayoutService.STORAGE_KEY,
        String(Math.round(width))
      );
    } catch {
      // localStorage unavailable
    }
  }
}
